import './footer.scss';

import React, { FunctionComponent } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import { FooterDesktop } from './FooterDesktop';
import { FooterMobile } from './FooterMobile';
import { FooterPolicy } from './FooterPolicy';
import { NewsletterOptin } from './NewsletterOptin';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';


const Footer: FunctionComponent = () => {
    const { t } = useTranslation('mainLayout');
    const currentLocale = usePageLocalization()
        .currentLocale;

    const data: Queries.FooterStaticQuery = useStaticQuery(
        graphql`
            query FooterStatic {
                sbiDescription: allProductsJson(
                    filter: { code: { eq: "sbi-description" } }
                ) {
                    nodes {
                        ...ProductJsonSimpleContent
                    }
                }
                customerServiceInfo: allProductsJson(
                    filter: { code: { eq: "century_customer-service" } }
                ) {
                    nodes {
                        ...contactUsInformationFragment
                    }
                }
                technicalSupportInfo: allProductsJson(
                    filter: { code: { eq: "century_technical-support" } }
                ) {
                    nodes {
                        ...contactUsInformationFragment
                    }
                }
            }
        `
    );

    const customerServiceInfo = data?.customerServiceInfo?.nodes?.[0];
    const technicalSupportInfo = data?.technicalSupportInfo?.nodes?.[0];

    return (
        <footer>
            <div className='container-100'>
                <NewsletterOptin />
            </div>
            <div className='footer-wrap container-100'>
                <div className='container'>
                    <FooterMobile />
                    <FooterDesktop
                        customerServiceInfo={customerServiceInfo}
                        technicalSupportInfo={technicalSupportInfo}
                    />
                    <FooterPolicy />
                </div>
            </div>
        </footer>
    );
};
export default Footer;
